import { Observable, firstValueFrom, from } from 'rxjs';

import { DexieService } from './dexieService';
import { GenericClassTranslate } from '../model/genericClass';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { OnlineService } from './online.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class ProcessService {

    constructor(private http: HttpClient,
        private dexieService: DexieService,
        private onlineService: OnlineService) {
    }

    findAll(): Observable<any> {
        if (this.onlineService.latestOnline) {
            const url = environment.coreUrl + '/processType/';

            return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
        } else {
            return from(this.dexieService.processType.toArray().timeout(30000));
        }
    }

    async saveProcessTypeToDexie(): Promise<void> {
        const res = await firstValueFrom(this.findAll());
        if (!res) return;

        await this.dexieService.processType.clear();

        await Promise.all(res.map(data => this.dexieService.processType.put(data, data.id)));
    }
}
